import { all } from 'redux-saga/effects';
import watchManager from './manager';
import watchInvalidateGetProjectsCache from './invalidateGetProjectsCache';
import watchRevokeUserToken from './revokeUserToken';

export default function* rootSaga() {
	yield all([watchManager(), watchInvalidateGetProjectsCache(), watchRevokeUserToken()]);
}
